import { DisplayInvoiceAddress } from '~/types/Address';

export const SHIPPO_US_ADDRESS: DisplayInvoiceAddress = {
  company: 'Popout, Inc.',
  email: 'info@shippo.com',
  street1: '731 Market Street',
  street2: 'Suite 200',
  city: 'San Francisco',
  state: 'CA',
  zip: '94103',
  country: 'United States',
};

export const SHIPPO_DE_ADDRESS: DisplayInvoiceAddress = {
  company: 'Shippo UG (haftungsbeschraenkt)',
  email: 'info@shippo.com',
  street1: 'Nuernberger Str. 91',
  city: 'Schnaittach',
  zip: '91220',
  country: 'Germany',
};
